const headerToggle = document.querySelector('.header__icons__toggle');
const spNav = document.querySelector('.sp-nav');
const spClose = document.querySelector('.sp-nav__close');
const spOverlay = document.querySelector('.sp-nav__overlay');
headerToggle.addEventListener('click', function(){
  spNav.classList.add('js-open');
});
spClose.addEventListener('click', function(){
  spNav.classList.remove('js-open');
});
spOverlay.addEventListener('click', function(){
  spNav.classList.remove('js-open');
});


const arrow = document.querySelectorAll('.sp-nav__category__arrow');
for (let i = 0; i < arrow.length; i++){
  let arrowEach = arrow[i];
  let content = arrowEach.nextElementSibling;
  arrowEach.addEventListener('click', () => {
    arrowEach.classList.toggle('js-active');
    content.classList.toggle('js-open');
  });
}